var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import { Text } from "../../../components/elements/Text";
export var Link = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: underline;\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", "\n"], ["\n  text-decoration: underline;\n  &:hover {\n    cursor: pointer;\n  }\n\n  ", "\n"])), function (_a) {
    var disableDecoration = _a.disableDecoration;
    if (disableDecoration) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        text-decoration: none;\n        &:hover {\n          cursor: default;\n        }\n      "], ["\n        text-decoration: none;\n        &:hover {\n          cursor: default;\n        }\n      "])));
    }
});
var templateObject_1, templateObject_2;
